if (!customElements.get('fa-delivery-estimate')) {
  class FifthAlloyDeliveryEstimate extends HTMLElement {
    static holidays(year) {
      const dates = new Set();
      const add = (date) => dates.add(date.toISOString().slice(0, 10));
      // New Year's Day can be observed on December 31 of the previous year.
      for (let y = year - 1; y <= year + 1; y += 1) {
        [[0, 1], [6, 4], [11, 25]].forEach(([month, day]) => {
          const date = new Date(Date.UTC(y, month, day));
          add(date);
          if (date.getUTCDay() === 6) date.setUTCDate(date.getUTCDate() - 1);
          else if (date.getUTCDay() === 0) date.setUTCDate(date.getUTCDate() + 1);
          add(date);
        });
        const memorial = new Date(Date.UTC(y, 4, 31));
        memorial.setUTCDate(31 - ((memorial.getUTCDay() + 6) % 7));
        add(memorial);
        const labor = new Date(Date.UTC(y, 8, 1));
        labor.setUTCDate(1 + ((8 - labor.getUTCDay()) % 7));
        add(labor);
        const thanksgiving = new Date(Date.UTC(y, 10, 1));
        thanksgiving.setUTCDate(22 + ((4 - thanksgiving.getUTCDay() + 7) % 7));
        add(thanksgiving);
      }
      return dates;
    }

    static addBusinessDays(date, count) {
      const result = new Date(date.getTime());
      if (!Number.isFinite(result.getTime()) || !Number.isInteger(count) || count < 0) return null;
      const holidays = FifthAlloyDeliveryEstimate.holidays(result.getUTCFullYear());
      let remaining = count;
      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        const day = result.getUTCDay();
        if (day !== 0 && day !== 6 && !holidays.has(result.toISOString().slice(0, 10))) remaining -= 1;
      }
      return result;
    }

    static estimate(orderDate, fulfillment) {
      const processingDays = fulfillment === 'rts' ? 5 : fulfillment === 'mto' ? 18 : 0;
      if (!processingDays || !/^\d{4}-\d{2}-\d{2}$/.test(orderDate)) return null;
      const date = new Date(`${orderDate}T00:00:00Z`);
      if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== orderDate) return null;
      const dispatch = FifthAlloyDeliveryEstimate.addBusinessDays(date, processingDays);
      return FifthAlloyDeliveryEstimate.addBusinessDays(dispatch, 1);
    }

    static storeDate(now, timeZone) {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(now);
      const get = (type) => parts.find((part) => part.type === type).value;
      return `${get('year')}-${get('month')}-${get('day')}`;
    }

    connectedCallback() {
      this.productRoot = this.closest('.js-product');
      this.dateLine = this.querySelector('[data-delivery-date]');
      this.timing = this.querySelector('[data-delivery-timing]');
      if (!this.dateLine || !this.timing) return;
      this.available = this.dataset.available === 'true';
      this.onVariantChange = (event) => {
        this.available = Boolean(event.detail.variant && event.detail.variant.available);
        this.refresh();
      };
      this.onVisibilityChange = () => {
        if (!document.hidden) this.refresh();
      };
      this.productRoot?.addEventListener('on:variant:change', this.onVariantChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.refresh();
      this.refreshTimer = window.setInterval(() => this.refresh(), 60000);
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('on:variant:change', this.onVariantChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      window.clearInterval(this.refreshTimer);
    }

    refresh() {
      if (!this.dateLine || !this.timing) return;
      this.timing.hidden = !this.available;
      if (!this.available) {
        this.dateLine.hidden = true;
        return;
      }
      let orderDate = this.dataset.orderDate;
      try {
        orderDate = FifthAlloyDeliveryEstimate.storeDate(new Date(), this.dataset.timeZone);
      } catch (error) {
        // Retain Shopify's render date if the browser cannot resolve the store timezone.
      }
      const estimate = FifthAlloyDeliveryEstimate.estimate(orderDate, this.dataset.fulfillment);
      if (!estimate) {
        this.dateLine.hidden = true;
        return;
      }
      const time = this.dateLine.querySelector('time');
      const dateTime = estimate.toISOString().slice(0, 10);
      if (time.dateTime !== dateTime) {
        time.dateTime = dateTime;
        time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
          timeZone: 'UTC', month: 'long', day: 'numeric',
          ...(estimate.getUTCFullYear() !== Number(orderDate.slice(0, 4)) ? { year: 'numeric' } : {})
        }).format(estimate);
      }
      this.dateLine.hidden = false;
    }
  }
  customElements.define('fa-delivery-estimate', FifthAlloyDeliveryEstimate);
}
